
import React from 'react'

export const SuccessEmailIcon = (props) => (
    <svg style={props.style} width="121" height="120" viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="120" height="120" rx="60" fill="#F6F6F6"/>
    <rect x="36.9004" y="44" width="48" height="32" rx="3" fill="#151D21"/>
    <path d="M42.4004 49.5L60.6504 61L78.9004 49.5" stroke="#F6F6F6" stroke-width="4"/>
    </svg>
)



